module.exports = __webpack_public_path__ + "static/media/webmd.925d0683.jpg";